import React, { useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import NotoSansKannada from "./NotoSansKannada";
import helperServices from "../../../shared/helper/helper";

function PrintPanchkarmaConsent(props) {
  const { patientInfo } = props;

  const name =
    patientInfo?.fullName ||
    [patientInfo?.fname, patientInfo?.mname, patientInfo?.lname]
      .filter(Boolean)
      .join(" ") ||
    "—";

  const field = (val) => val || "—";

  useEffect(() => {
    props.parentCallBack();
    printConsent();
  }, []);

  const buildDocDefinition = () => {
    const ipopNo = field(patientInfo?.ipopnumber);
    const doctorName = field(patientInfo?.doctorName);

    const procedures = Array.isArray(patientInfo?.procedures)
      ? patientInfo.procedures
      : [];

    const procedureTable = (lang) => {
      const isKn = lang === "kn";
      const font = isKn ? "NotoSansKannada" : "Roboto";
      const headings = isKn
        ? [
            "ಕಾರ್ಯವಿಧಾನದ ಹೆಸರು",
            "ಒಪ್ಪಿಗೆಯನ್ನು ತೆಗೆದುಕೊಂಡವರ ಹೆಸರು",
            "ದಿನಾಂಕ",
            "ರೋಗಿಯ / ಸಂಬಂಧಿ ಸಹಿ",
          ]
        : [
            "Name of the Procedure",
            "Consent Taken by",
            "Date",
            "Patient / Relative Signature",
          ];

      const procedureRows = procedures.map((procedure) => {
        const signature = procedure?.signature || null;

        return [
          {
            text: field(procedure?.procedureName),
            font,
            fontSize: 10,
            border: [true, true, true, true],
            margin: [2, 10, 2, 10],
          },
          {
            text: field(procedure?.takenBy),
            font,
            fontSize: 10,
            border: [true, true, true, true],
            margin: [2, 10, 2, 10],
          },
          {
            text:
              helperServices.formatDateOnly(procedure?.date, true) || "—",
            font,
            fontSize: 10,
            alignment: "center",
            border: [true, true, true, true],
            margin: [2, 10, 2, 10],
          },
          signature
            ? {
                image: signature,
                fit: [100, 35],
                alignment: "center",
                border: [true, true, true, true],
                margin: [2, 5, 2, 5],
              }
            : {
                text: "—",
                font,
                fontSize: 10,
                alignment: "center",
                border: [true, true, true, true],
                margin: [2, 10, 2, 10],
              },
        ];
      });

      return {
        table: {
          widths: ["30%", "28%", "16%", "26%"],
          body: [
            headings.map((heading) => ({
              text: heading,
              bold: true,
              font,
              fontSize: 10,
              border: [true, true, true, true],
              fillColor: "#f2f2f2",
              margin: [2, 4, 2, 4],
            })),
            ...procedureRows,
          ],
        },
        margin: [0, 10, 0, 0],
      };
    };

    return {
      pageSize: "A4",
      pageMargins: [30, 30, 30, 30],
      defaultStyle: { font: "Roboto" },

      content: [
        {
          text: "PANCHAKARMA CONSENT",
          fontSize: 14,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 16],
        },

        {
          text: [
            "I  ",
            { text: name, bold: true },
            "  OPD/IPD NO. ",
            { text: ipopNo, bold: true },
            "  exercises my free favor of choice hereby give my consent to be treated with subject to Karma (Procedure) mentioned below. I have been informed to my satisfaction, by the attending physician Dr. ",
            { text: doctorName, bold: true },
            " the purpose of this karma / procedure and the nature of drug treatment to monitor and safeguard my body functions. My name and other details will be confidential. I am also aware of complications, provalve outcome of treatment at any time during the course of treatment without having to give the reasons of doing so.",
          ],
          fontSize: 10,
          margin: [0, 0, 0, 14],
        },

        procedureTable("en"),

        {
          text: "ಪಂಚಕರ್ಮ ಒಪ್ಪಿಗೆ",
          pageBreak: "before",
          font: "NotoSansKannada",
          fontSize: 14,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 16],
        },

        {
          text: [
            { text: "ನಾನು ", font: "NotoSansKannada" },
            { text: name, bold: true },
            { text: " OPD/IPD NO. " },
            { text: ipopNo, bold: true },
            {
              text: " ನನಗೆ ಕೆಳಗೆ ತಿಳಿಸಲಾದ ಕರ್ಮ (ವಿಧಾನ)ಕ್ಕೆ ಒಳಪಟ್ಟು ಚಿಕಿತ್ಸೆಯನ್ನು ಪಡೆಯಲು ನನ್ನ ಒಪ್ಪಿಗೆಯನ್ನು ನೀಡಿರುತ್ತೇನೆ. ನನ್ನ ದೇಹ ಕಾರ್ಯಗಳನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡಲು ಮತ್ತು ರಕ್ಷಿಸಲು ಈ ಕರ್ಮದ / ಕಾರ್ಯವಿಧಾನದ ಅಗತ್ಯ ಮತ್ತು ಔಷಧ ಚಿಕಿತ್ಸೆಯ ಸ್ವರೂಪವನ್ನು ಹಾಜರಾದ ವೈದ್ಯರಿಂದ ನನಗೆ ತೃಪ್ತಿಪಡಿಸುವಂತೆ ತಿಳಿಸಲಾಗಿದೆ. ನನ್ನ ಹೆಸರು ಮತ್ತು ಇತರ ವಿವರಗಳು ಗೌಪ್ಯವಾಗಿರುತ್ತದೆ. ನಾನು ತೊಡಕುಗಳ ಬಗ್ಗೆಯೂ ಸಹ ತಿಳಿದಿರುತ್ತೇನೆ, ಚಿಕಿತ್ಸೆಯ ಸಮಯದಲ್ಲಿ ಯಾವುದೇ ಕಾರಣಗಳನ್ನು ನೀಡದೆ ಚಿಕಿತ್ಸೆಯ ಫಲಿತಾಂಶವನ್ನು ಸಾಬೀತುಪಡಿಸುತ್ತದೆ.",
              font: "NotoSansKannada",
            },
          ],
          fontSize: 10,
          margin: [0, 0, 0, 10],
        },

        procedureTable("kn"),
      ],
    };
  };

  const printConsent = () => {
    pdfMake.vfs = {
      ...pdfFonts.pdfMake.vfs,
      "NotoSansKannada-Regular.ttf": NotoSansKannada,
    };

    pdfMake.fonts = {
      Roboto: {
        normal: "Roboto-Regular.ttf",
        bold: "Roboto-Medium.ttf",
        italics: "Roboto-Italic.ttf",
        bolditalics: "Roboto-MediumItalic.ttf",
      },
      NotoSansKannada: {
        normal: "NotoSansKannada-Regular.ttf",
        bold: "NotoSansKannada-Regular.ttf",
      },
    };

    const docDefinition = buildDocDefinition();

    pdfMake.createPdf(docDefinition).getBlob((blob) => {
      const url = URL.createObjectURL(blob);

      window.open(
        `/Patient_Profile_Print?file=${encodeURIComponent(url)}`,
        "_blank"
      );
    });
  };

  return null;
}

export default PrintPanchkarmaConsent;
